import { Col, Row, Spin } from "antd";

import useProveedorData from "../../hooks/useProveedorData";
import AlertMessage from "../alert-message/alert-message.component";
import UploadFile from "../file/uploadFile.component";
import { messages } from "./proveedor.messages";

const Proveedor = () => {
    // TODO: Recuperar los datos del proveedor (por el momento son solo archivos) (Puede tener o no)
    const { filesToUpload, loading, error } = useProveedorData();

    const filesToUploadTitles = Object.keys(filesToUpload);

    const { loading: loadingMsg, error: errorMsg } = messages;

    return (
        <div className='content'>
            {error ? (
                <AlertMessage message={errorMsg} type='error' />
            ) : (
                <Spin spinning={loading} tip={loadingMsg}>
                    <Row gutter={[8, 48]} style={{ marginTop: "40px" }}>
                        {filesToUploadTitles.map((title) => {
                            const file = {
                                ...filesToUpload[title],
                                name: title,
                            };
                            return (
                                <Col key={title} span={24}>
                                    <UploadFile file={file} />
                                </Col>
                            );
                        })}
                    </Row>
                </Spin>
            )}
        </div>
    );
};

export default Proveedor;
